import styled from 'styled-components';

export const Rectangle = styled.div<{
	size?: string;
	backgroundColor?: string;
	borderColor?: string;
	borderWidth?: string;
	borderStyle?: string;
}>`
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: ${(p) => p.size || '2rem'};
	min-width: ${(p) => p.size || '2rem'};
	background-color: ${(p) => p.backgroundColor || ''};
	border-radius: 10px;
	border-width: ${(p) => p.borderWidth || ''};
	border-style: ${(p) => p.borderStyle || ''};
	border-color: ${(p) => p.borderColor || ''};
	flex-shrink: 0;
	flex-grow: 0;
	-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
	transition: background-color 0.5 ease-in-out;
`;
